define('models/StoreBenefitModel',['underscore', 'app', 'ObjectModel'],
    function (_, app, ObjectModel) {
        //
        // StoreBenefitModel
        //
        var StoreBenefitModel = ObjectModel.extend({
            name:'StoreBenefitModel',
            idAttribute:'id_store_benefit',
            route:'apiStoreBenefitModel',
            initialize:function(){
                // ObjectModel constructor heritage
                ObjectModel.prototype.initialize.apply(this,arguments);
                //
            },
            getName:function() {
            var  name = this.get('name');
                return name;
            },
            isChecked:function(){
                return this.get('filterChecked')
            },
        });

        return StoreBenefitModel;

    });
